import { render, staticRenderFns } from "./01-channels.vue?vue&type=template&id=5b3d5cda"
import script from "./01-channels.vue?vue&type=script&lang=ts"
export * from "./01-channels.vue?vue&type=script&lang=ts"
import style0 from "./01-channels.vue?vue&type=style&index=0&id=5b3d5cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports